 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import CONTENTCONTENT0007 from '@/components/content/content0007'
 import CONTENTCONTENT0009 from '@/components/content/content0009'
 import CONTENTCONTENT0011 from '@/components/content/content0011'
 import CONTENTCONTENT0012 from '@/components/content/content0012'
 import CONTENTCONTENT0015 from '@/components/content/content0015'
 import CONTENTCONTENT0018 from '@/components/content/content0018'
 import CONTENTCONTENT0021 from '@/components/content/content0021'
 import CONTENTCONTENT0026 from '@/components/content/content0026'
 import CONTENTCONTENT0045 from '@/components/content/content0045'
 import CONTENTCONTENT0048 from '@/components/content/content0048'
 import CONTENTCONTENT0050 from '@/components/content/content0050'
 import CONTENTCONTENT0051 from '@/components/content/content0051'
 import CONTENTCONTENT0056 from '@/components/content/content0056'
 import CONTENTCONTENT0058 from '@/components/content/content0058'
 import CONTENTCONTENT0062 from '@/components/content/content0062'
 import CONTENTCONTENT0063 from '@/components/content/content0063'
 import CONTENTCONTENT0065 from '@/components/content/content0065'
 import CONTENTCONTENT0066 from '@/components/content/content0066'
 import CONTENTCONTENT0067 from '@/components/content/content0067'
 import CONTENTCONTENT0068 from '@/components/content/content0068'
 import CONTENTCONTENT0069 from '@/components/content/content0069'
 import CONTENTCONTENT0070 from '@/components/content/content0070'
 import CONTENTCONTENT0071 from '@/components/content/content0071'
 import CONTENTCONTENT0072 from '@/components/content/content0072'
 import CONTENTCONTENT0073 from '@/components/content/content0073'
 import CONTENTCONTENT0074 from '@/components/content/content0074'
 import CONTENTCONTENT0075 from '@/components/content/content0075'
 import CONTENTCONTENT0076 from '@/components/content/content0076'
 import CONTENTCONTENT0079 from '@/components/content/content0079'
 import CONTENTCONTENT0080 from '@/components/content/content0080'
 import CONTENTCONTENT0081 from '@/components/content/content0081'
 import CONTENTCONTENT0082 from '@/components/content/content0082'
 import CONTENTCONTENT0113 from '@/components/content/content0113'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/content/content0007",
 			"name" : "content/content0007",
 			"component" : CONTENTCONTENT0007
 		},
 		{
 			"path" : "/content/content0009",
 			"name" : "content/content0009",
 			"component" : CONTENTCONTENT0009
 		},
 		{
 			"path" : "/content/content0011",
 			"name" : "content/content0011",
 			"component" : CONTENTCONTENT0011
 		},
 		{
 			"path" : "/content/content0012",
 			"name" : "content/content0012",
 			"component" : CONTENTCONTENT0012
 		},
 		{
 			"path" : "/content/content0015",
 			"name" : "content/content0015",
 			"component" : CONTENTCONTENT0015
 		},
 		{
 			"path" : "/content/content0018",
 			"name" : "content/content0018",
 			"component" : CONTENTCONTENT0018
 		},
 		{
 			"path" : "/content/content0021",
 			"name" : "content/content0021",
 			"component" : CONTENTCONTENT0021
 		},
 		{
 			"path" : "/content/content0026",
 			"name" : "content/content0026",
 			"component" : CONTENTCONTENT0026
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js